import { contexts } from 'constants/context';

const contextsThatHideHeader = [
  contexts.home,
  contexts.register,
  contexts.login,
  contexts.signUp,
  contexts.addAddress,
];
const contextsThatHideSidebar = [
  contexts.home,
  contexts.register,
  contexts.login,
  contexts.signUp,
  contexts.addAddress,
];

const hideElements = {
  contextsThatHideHeader,
  contextsThatHideSidebar,
};

export default hideElements;
